export default __webpack_public_path__ + "images/1ec570a78b282cfab29d549d5f0c0c12-RTTSync.svg";